import { createFileRoute } from '@tanstack/react-router'
import { InvoicePrintPage } from '../../../../features/sales/invoice-print-page'
import { printSearchSchema } from '../../../../features/sales/search'

export const Route = createFileRoute('/_app/invoices/$invoiceId/print')({
  staticData: { crumb: 'invoicePrint' },
  validateSearch: printSearchSchema,
  component: InvoicePrintPage,
})
